// extracted by mini-css-extract-plugin
export default {"index":"index_index_9tqe6","mainTitle":"index_mainTitle_InnG9","btn":"index_btn_xvTlM","logo":"index_logo_-DXZt","time":"index_time_MKYMC"};